export default __webpack_public_path__ + "static/media/created.426be469.svg";